import React, { useState, useEffect, useRef } from "react";
import { toastr } from "react-redux-toastr";
import axios from "axios";

import { useNavigate } from "react-router-dom";
import { connectLoginPopUp } from "../loginPopUp.connect";
import { setUserDataSuccess } from "../../../store/user/user.slice";
import { updateToken } from "../../../store/auth/auth.thunks";
import { useDispatch, useSelector } from "react-redux";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";

import SVG_EyeIcon from "../../../assets/images/svgs/eye.svg?react";
import SVG_EyeOffIcon from "../../../assets/images/svgs/eyeoff.svg?react";
import SVG_UserIcon from "../../../assets/images/svgs/user_2.svg?react";
import SVG_UserWhiteIcon from "../../../assets/images/svgs/user_3.svg?react";
import SVG_ChevronDownIcon from "../../../assets/images/svgs/chevronDown3.svg?react";
import SVG_MobileIcon from "../../../assets/images/svgs/Mobile2.svg?react";
import SVG_LockIcon from "../../../assets/images/svgs/lock_2.svg?react";
import flagSVG from "../../../assets/images/svgs/flag.svg?q=65&amp;w=625&amp;ar=0.75&amp;px=auto&amp;auto=format&amp;fit=fill&amp;blur=0";
import PasswordValidation from "../../PasswordValidation";
import SVG_CallIcon from "../../../assets/images/svgs/callIcon.svg?react";
import SVG_WhatsAppIcon from "../../../assets/images/svgs/whatsappIcon.svg?react";
import CountryCodeDropdown, {
  mobileFlag,
  mobileLengths,
} from "../CountryCodeDrpodown";
import { useClickSound } from "../../ClickSoundProvider/ClickSoundProvider";


const ForgotPasswordTab = ({
  actions,
  recaptchaResponse,
  onDidDismiss,
  changeTab,
  width,
  loginNavigation,
  signUp,
  logo,
}) => {
  const navigate = useNavigate();


  const [step, setStep] = useState(5);
  const [isSending, setIsSending] = useState(false);
  const [orderID, setOrderID] = useState("");
  const [mobile, setMobile] = useState("");
  const dispatch = useDispatch();

  const initialMinute = 0,
    initialSeconds = 59;
  const [minutes, setMinutes] = useState(initialMinute);
  const [seconds, setSeconds] = useState(initialSeconds);
  const [openDropdownList, setOpenDropdownList] = useState(false);
  const [dropdownAnimate, setDropdownAnimate] = useState("");
  const [loginType, setLoginType] = useState("mobile");
  const [hideFirstPass, setHideFirstPass] = useState(false);
  const [hideSecondPass, setHideSecondPass] = useState(false);
  const [showPassValidation, setShowPassValidation] = useState(false);
  const [showPasswordRules, setShowPasswordRules] = useState(false);

  const { playClick } = useClickSound();

  useEffect(() => {
    if (step === 2) {
      let myInterval = setInterval(() => {
        if (seconds > 0) {
          setSeconds(seconds - 1);
        }
        if (seconds === 0) {
          if (minutes === 0) {
            clearInterval(myInterval);
          } else {
            setMinutes(minutes - 1);
            setSeconds(59);
          }
        }
      }, 1000);
      return () => {
        clearInterval(myInterval);
      };
    }
  });

  const [otpSent, setOtpSent] = useState(false);
  const [isSendingNew, setIsSendingNew] = useState(false);

  const mobileValidationNew = async (mobileNum, countryCode) => {
    setIsSendingNew(true);

    if (
      !mobileNum ||
      mobileNum?.length <
        (loginType === "mobile" ? mobileLengths[countryCode] || 10 : 3)
    ) {
      return;
    } else {
      const data = {
        country_code: `+${countryCode || "91"}`,
        ...(loginType === "mobile"
          ? { mobile: `${mobileNum}` }
          : { user_name: `${mobileNum}` }),
      };

      await actions
        .forgotPasswordOtp(data)
        .then((res) => {
          if (res.status === 200) {
            if (res?.data?.status) {
              let mobile = res?.data?.mobile;
              let lastDigit = String(mobile).slice(-4);
              console.log("Mobile", mobile, lastDigit);
              toastr.success("", `${res?.data?.msg}`);
              setOtpSent(true);
              setOrderID(res?.data?.data?.orderId);
              setMobile(lastDigit);
              res?.data?.otp_expiry_time &&
                setSecondsNew(Number(res?.data?.otp_expiry_time));
            } else {
              setIsSendingNew(false);
              toastr.error("", `${res?.data?.msg}`);
            }
          }
        })
        .catch((e) => {
          setIsSendingNew(false);
          toastr.error("", `${e?.msg || e?.data?.msg}`);
        });
    }
  };

  const resendOTP = async () => {
    const dataOTP = {
      orderId: orderID,
    };

    await actions
      .resendForgotOTP(dataOTP)
      .then((res) => {
        if (res.status) {
          toastr.success("", `${res.data.msg}`);
          setOtpSent(true);
          setOrderID(res?.data?.data?.orderId);
          res?.data?.otp_expiry_time &&
            setSecondsNew(Number(res?.data?.otp_expiry_time));
        }
      })
      .catch((e) => toastr.error("", `${e}`));
  };

  const verifyOtp = async (otp) => {
    // setIsSendingNew(true);

    if (!orderID) {
      toastr.error("", "Please send OTP first!");
      return false;
    }

    const dataForOTP = {
      orderId: orderID,
      otp: otp,
    };

    try {
      const res = await actions.verifyForgotOTP(dataForOTP);

      if (res.status === 200 && res?.data) {
        if (res.data.status) {
          // toastr.success("", res.data.msg);
          return true;
        } else {
          toastr.error("", res.data.msg || res.msg);
        }
      }
    } catch (e) {
      toastr.error("", e?.data?.msg || e?.msg);
    } finally {
      // setIsSendingNew(false);
    }

    return false;
  };

  const initialMinuteNew = 0,
    initialSecondsNew = 59;
  const [minutesNew, setMinutesNew] = useState(initialMinuteNew);
  const [secondsNew, setSecondsNew] = useState(initialSecondsNew);

  useEffect(() => {
    if (otpSent) {
      let myIntervalNew = setInterval(() => {
        if (secondsNew > 0) {
          setSecondsNew(secondsNew - 1);
        }
        if (secondsNew === 0) {
          if (minutesNew === 0) {
            clearInterval(myIntervalNew);
          } else {
            setMinutesNew(minutesNew - 1);
            setSecondsNew(59);
          }
        }
      }, 1000);
      return () => {
        clearInterval(myIntervalNew);
      };
    }
  });

  const initialValues = {
    countryCode: "91",
    userId: "",
    mobileNum: "",
    otp: "",
    password: "",
    conPassword: "",
  };

  const validationSchema = Yup.object().shape({
    userId:
      loginType == "user"
        ? Yup.string().required("User ID is required")
        : Yup.string().nullable(),
    countryCode:
      loginType == "mobile"
        ? Yup.string().required("Country is required")
        : Yup.string().nullable(),
    mobileNum:
      loginType == "mobile"
        ? Yup.string()
            .matches(/^\d+$/, "Phone Number must only contain digits")
            .when("countryCode", (countryCode, schema) => {
              const length = mobileLengths[countryCode] || 10;
              return schema
                .min(length, `Phone Number must be ${length} digits`)
                .max(length, `Phone Number must be ${length} digits`)
                .required("Phone Number is required");
            })
        : Yup.string().nullable(),
    otp: Yup.string()
      .min(6, "Otp must be 6 digits long")
      .required("Otp Required"),
    password: Yup.string()
      .required("Password is required")
      .min(6, "Must be at least 6 characters"),
    conPassword: Yup.string()
      .required("This field is required")
      .oneOf([Yup.ref("password"), null], "Password does not match."),
  });

  const isMobile = useSelector((state) => state.promotions?.isMobile);

  const onSubmit = async (values) => {
    playClick();
    if (isMobile && !orderID) return;

    setIsSending(true);

    const data = {
      orderId: orderID,
      newPassword: `${values.password}`,
      confirmPassword: `${values.conPassword}`,
    };

    // if (isMobile) {
      const otpSuccess = await verifyOtp(values.otp);

      if (!otpSuccess) {
        setIsSending(false);
        return;
      }
    // }

    await actions
      .resetPassword(data)
      .then((res) => {
        if (res.status === 200) {
          if (res?.data) {
            res?.data?.status
              ? toastr.success("", res?.data?.msg)
              : toastr.error("", res?.data?.msg || res?.msg);
          }

          if (res?.data?.status) {
            setIsSending(false);
            onDidDismiss(false);
          } else {
            setIsSending(false);
          }
        }
      })
      .catch((e) => {
        setIsSending(false);
        toastr.error("", `${e?.data?.msg || e?.msg}`);
      });
  };

  const dropdownList = [
    {
      id: "mobile",
      message: "Mobile Number",
      icon: <SVG_MobileIcon fill={"#6B7280"} />,
      activeIcon: <SVG_MobileIcon fill={"var(--color-primary)"} />,
    },
    {
      id: "user",
      message: "User Id",
      icon: <SVG_UserWhiteIcon />,
      activeIcon: <SVG_UserIcon width={16} height={16} />,
    },
  ];

  const handleLoginType = (value) => {
    setDropdownAnimate("popUpCloseAnimation");
    setTimeout(() => {
      setOpenDropdownList(false);
      setLoginType(value);
    }, 200);
  };

  const handledropdownOpen = () => {
    if (!openDropdownList) {
      setDropdownAnimate("popUpOpenAnimation");
      setOpenDropdownList(true);
    } else {
      setDropdownAnimate("popUpCloseAnimation");
      setTimeout(() => {
        setOpenDropdownList(false);
      }, 200);
    }
  };

  const OptionDropdown = () => {
    return (
      <span className=" h-fit">
        <div className="w-full h-full relative ">
          <div className=" block z-100 h-full">
            <div
              id="dropdownDefaultButton"
              className="w-full cursor-pointer relative hover:undefined font-medium  rounded-r-sm min-h-[35px] text-sm  pr-6 text-center inline-flex items-center bg-bg_BgGray text-text_Quaternary"
              onClick={() => {
                handledropdownOpen();
              }}
            >
              {loginType == "user" ? <SVG_UserIcon /> : <SVG_MobileIcon />}
              <SVG_ChevronDownIcon
                className={`w-5 h-5 ms-3 absolute right-1 transform transition-all ease-in-out duration-200 ${
                  openDropdownList ? "-rotate-180" : ""
                }`}
              />
            </div>

            {openDropdownList && (
              <div
                id="dropdown"
                className={`${dropdownAnimate} bg-bg_Quaternary right-1  origin-top-right top-[102%]  absolute  z-10  divide-y divide-gray-500 rounded-lg shadow w-max  bg-bg_Quaternary text-text_Secondary`}
              >
                <ul className="py-1 text-sm text-text_Quaternary">
                  {dropdownList.map((item, index) => {
                    return (
                      <li
                        key={`${item.id}-dropdown`}
                        className={` active:bg-bg_Secondary   ${
                          index == 0
                            ? "border-b-[1px] pb-1"
                            : "text-text_Primary  pt-1"
                        }`}
                      >
                        <button
                          type="button"
                          className="w-full px-4 py-1 grid grid-cols-4"
                          onClick={() => {
                            handleLoginType(item.id);
                          }}
                        >
                          <span className=" col-span-1 flex items-center justify-center ">
                            {item.id == loginType ? item.activeIcon : item.icon}
                          </span>
                          <span
                            className={` col-span-3 pl-2 font-normal f] font-lato text-start text-red-600  ${
                              item.id == loginType
                                ? "text-text_Primary"
                                : "text-gray-500"
                            } `}
                          >
                            {item?.message}
                          </span>
                        </button>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
          </div>
        </div>
      </span>
    );
  };

  return (
    <>
      <div className="flex gap-10 items-start h-[95%] lg:h-auto w-full">
        <div className=" hidden   lg:w-[50%] rounded-lg overflow-hidden">
          <img
            src={`/assets/images/${window.location.hostname
              .replace("www.", "")
              .replace("app.", "")}/logo_2.png`}
            alt="register banner"
          />
        </div>
        <div
          title="mobileLogin"
          className="flex flex-col  items-start gap-y-4 w-full "
        >
          <div className="logo w-full lg:hidden flex items-center justify-center">
            <img src={logo} alt="register banner" />
          </div>

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({
              values,
              handleChange,
              handleBlur,
              handleSubmit,
              errors,
              touched,
            }) => (
              <form
                className="w-full  flex flex-col"
                autoComplete="on"
                onSubmit={handleSubmit}
              >
                {/* Start user or mobile */}
                <div title="loginFormMonileUserIdInput" className=" w-full ">
                  <div className="flex w-full items-center py-1  bg-bg_BgGray rounded-lg border">
                    {loginType == "user" ? (
                      <input
                        id="userId-input"
                        className="block focus:outline-none   w-full px-2 rounded-md font-lato text-text_Ternary  text-sm xs:text-md bg-bg_BgGray "
                        placeholder="User Id"
                        autoComplete="userName"
                        type="text"
                        name="userId"
                        value={values.userId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    ) : (
                      <>
                        <span
                          id="dropdown-phone-button"
                          className="flex-shrink-0 z-10 inline-flex items-center pl-2 pr-1 text-sm sm:text-md font-lato font-normal text-center"
                        >
                          +{values.countryCode || "91"}
                          <div className="relative overflow-hidden w-max h-max ml-1">
                            <span className="f32">
                              <div
                                className={`flag ${
                                  mobileFlag[values.countryCode] || "in"
                                } w-full`}
                              ></div>
                            </span>
                          </div>
                          <CountryCodeDropdown
                            countryType={values.countryCode}
                            handleCountryType={(countryCode) => {
                              handleChange({
                                target: {
                                  name: "countryCode",
                                  value: countryCode,
                                },
                              });
                            }}
                          />
                        </span>
                        <input
                          id="mobile-no-input"
                          className="block focus:outline-none   w-full font-lato bg-bg_BgGray  text-text_Ternary  pr-2 text-sm xs:text-md"
                          placeholder="895XX6XXXX"
                          autoComplete="phoneNo"
                          type="tel"
                          maxLength={mobileLengths[values.countryCode] || 10}
                          name="mobileNum"
                          value={values.mobileNum}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </>
                    )}
                    <OptionDropdown />
                  </div>
                  {loginType == "user" ? (
                    <ErrorMessage
                      name={"userId"}
                      component="div"
                      className="text-xs  ml-1 text-text_Danger  "
                    />
                  ) : (
                    <ErrorMessage
                      name={"mobileNum"}
                      component="div"
                      className="text-xs  ml-1 text-text_Danger  "
                    />
                  )}

                  {otpSent && mobile && (
                    <div className="text-xs  ml-1 text-text_Success  ">
                      Otp Sent on XXXX{mobile}
                    </div>
                  )}
                </div>
                {/* End User or Mobile */}

                <div className="w-full grid  grid-cols-1 xs:grid-cols-2 gap-2 overflow-hidden py-2 mt-2">
                  <button
                    type="button"
                    className="w-full border min-h-[36px]  transition-all ease-in-out text-xs whitespace-nowrap mr-1 py-2 sm:py-2.5 px-3 rounded-md font-medium shadow-sm  flex items-center justify-center gap-x-2 active:scale-[0.98] active:opacity-95 cursor-pointer bg-bg_color_input_bg border-border_color_primary1 text-text_color_loginInputTextColor disabled:opacity-60 disabled:cursor-not-allowed"
                    disabled={
                      loginType == "user"
                        ? !values.userId || values.userId.length < 3
                        : !values.mobileNum ||
                          values.mobileNum.length <
                            (mobileLengths[values.countryCode] || 10) ||
                          !values.mobileNum.match(
                            /^\d+$/,
                            "Phone Number must only contain digits",
                          ) ||
                          otpSent
                    }
                    // onClick={() =>
                    //   !otpSent
                    //     ? mobileValidationNew(
                    //         loginType === "mobile"
                    //           ? values.mobileNum
                    //           : values.userId,
                    //         values.countryCode
                    //       )
                    //     : null
                    // }
                  >
                    <span>
                      <SVG_CallIcon />
                    </span>
                    <span>SMS OTP</span>
                  </button>
                  <button
                    type="button"
                    className="w-full border min-h-[36px]  transition-all ease-in-out text-xs whitespace-nowrap mr-1 py-2 sm:py-2.5 px-3 rounded-md font-medium shadow-sm  flex items-center justify-center gap-x-2 active:scale-[0.98] active:opacity-95 cursor-pointer  text-text_color_primary2  bg-bg_color_LoginBtnBgColor border-border_color_brand_secondary1 disabled:opacity-60 disabled:cursor-not-allowed"
                    disabled={
                      loginType == "user"
                        ? !values.userId || values.userId.length < 3
                        : !values.mobileNum ||
                          values.mobileNum.length <
                            (mobileLengths[values.countryCode] || 10) ||
                          !values.mobileNum.match(
                            /^\d+$/,
                            "Phone Number must only contain digits",
                          ) ||
                          otpSent
                    }
                    onClick={() =>
                      !otpSent
                        ? mobileValidationNew(
                            loginType === "mobile"
                              ? values.mobileNum
                              : values.userId,
                            values.countryCode,
                          )
                        : null
                    }
                  >
                    <span>
                      <SVG_WhatsAppIcon />
                    </span>
                    <span>OTP</span>
                  </button>
                </div>

                <div className="flex flex-col  mt-2">
                  <div className="flex w-full items-center border p-1 bg-bg_BgGray rounded-lg">
                    <input
                      id="otpSignUp"
                      className="block focus:outline-none   w-full font-lato rounded-none py-1 text-text_Ternary  px-2 text-sm xs:text-md bg-bg_BgGray"
                      placeholder="Enter OTP"
                      inputMode="numeric"
                      disabled={
                        (loginType == "user"
                          ? values.userId.length < 3
                          : values.mobileNum.length <
                            (mobileLengths[values.countryCode] || 10)) ||
                        !otpSent
                      }
                      autoComplete="none"
                      type="tel"
                      name="otp"
                      maxLength={6}
                      value={values.otp}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>

                  <div
                    id="phoneNumberValidations"
                    className=" flex w-full items-center justify-between px-1"
                  >
                    {errors.otp && touched.otp && (
                      <span className=" text-xs text-text_Danger">
                        {errors.otp}
                      </span>
                    )}
                    {isSendingNew && (
                      <span className=" text-xs text-text_ResendOtpColor font-lato-bold">
                        <button
                          className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out  flex items-center justify-center gap-x-2 cursor-pointer"
                          type="button"
                          onClick={() => {
                            if (secondsNew === 0) {
                              resendOTP();
                            }
                          }}
                        >
                          <span className=" text-text_ResendOtpColor underline">
                            Resend OTP
                            {minutesNew === 0 && secondsNew === 0 ? null : (
                              <>
                                {" "}
                                in {minutesNew}:
                                {secondsNew < 10
                                  ? `0${secondsNew}`
                                  : secondsNew}
                              </>
                            )}
                          </span>
                        </button>
                      </span>
                    )}
                  </div>
                </div>

                <>
                  <div className="flex w-full items-center justify-between bg-bg_BgGray rounded-lg p-1 border mt-4">
                    <div className=" w-full h-full flex items-center justify-start pl-1">
                      <span className=" mb-1 py-1">
                        <SVG_LockIcon fill="var(--color-primary)" />
                      </span>
                      <span className=" w-full relative h-full">
                        <input
                          id="passwordSignUp"
                          className="block focus:outline-none   w-full h-full py-1 rounded-none text-text_Ternary  px-2 text-sm xs:text-md font-lato bg-bg_BgGray"
                          placeholder="Password"
                          disabled={
                            (loginType == "user"
                              ? values.userId.length < 3
                              : values.mobileNum.length <
                                (mobileLengths[values.countryCode] || 10)) ||
                            !otpSent
                          }
                          autoComplete="none"
                          type={hideFirstPass ? "text" : "password"}
                          name="password"
                          value={values.password}
                          onChange={handleChange}
                          onFocus={() => {
                            setShowPasswordRules(true);
                          }}
                          onBlur={(e) => {
                            handleBlur(e);
                            setShowPasswordRules(false);
                          }}
                        />
                        {showPasswordRules && (
                          <PasswordValidation
                            open={showPassValidation}
                            setOpen={(val) => {
                              setShowPassValidation(val);
                            }}
                            password={values.password}
                          />
                        )}
                      </span>
                    </div>
                    <span className="py-1">
                      <button
                        className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out pr-2 flex items-center justify-center cursor-pointer"
                        type="button"
                        onClick={() => {
                          setHideFirstPass(!hideFirstPass);
                        }}
                      >
                        {hideFirstPass ? <SVG_EyeOffIcon /> : <SVG_EyeIcon />}
                      </button>
                    </span>
                  </div>
                </>

                <div className="mb-4">
                  <div className="flex w-full items-center justify-between  bg-bg_BgGray rounded-lg border p-1 mt-4">
                    <div className=" w-full h-full flex items-center justify-start pl-1">
                      <span className=" mb-1">
                        <SVG_LockIcon fill="var(--color-primary)" />
                      </span>
                      <input
                        id="confirmpasswordSignUp"
                        className="block  focus:outline-none   w-full rounded-none text-text_Ternary  px-2 py-1 text-sm xs:text-md font-lato bg-bg_BgGray"
                        placeholder="Confirm Password"
                        disabled={
                          (loginType == "user"
                            ? values.userId.length < 3
                            : values.mobileNum.length <
                              (mobileLengths[values.countryCode] || 10)) ||
                          !otpSent
                        }
                        autoComplete="none"
                        type={hideSecondPass ? "text" : "password"}
                        name="conPassword"
                        value={values.conPassword}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </div>
                    <span>
                      <button
                        className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out  pr-2 flex items-center justify-center cursor-pointer"
                        type="button"
                        onClick={() => {
                          setHideSecondPass(!hideSecondPass);
                        }}
                      >
                        {hideSecondPass ? <SVG_EyeOffIcon /> : <SVG_EyeIcon />}
                      </button>
                    </span>
                  </div>
                  <div
                    id="passwordValidation"
                    className=" flex w-full items-center justify-start mt-1 px-1"
                  >
                    <span className=" text-xs text-text_Danger font-lato">
                      {errors.conPassword && touched.conPassword
                        ? errors.conPassword
                        : ""}
                    </span>
                  </div>
                </div>

                <div title="loginButton" className=" w-full">
                  <button
                    type="submit"
                    disabled={isSending}
                    className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out w-full text-text_Quaternary  bg-bg_color_LoginBtnBgColor shadow-lg rounded-md xs:text-[15px] px-5 py-2 flex items-center justify-center gap-x-2 font-lato-bold font-semibold text-base cursor-pointer"
                  >
                    Update Password
                    {isSending && (
                      <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                        <svg
                          className="animate-spin"
                          fill="var(--color-quaternary)"
                          version="1.1"
                          id="Capa_1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          width="20px"
                          height="20px"
                          viewBox="0 0 32.707 32.707"
                          xmlSpace="preserve"
                          stroke="#ffffff"
                        >
                          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                          <g
                            id="SVGRepo_tracerCarrier"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></g>
                          <g id="SVGRepo_iconCarrier">
                            <g>
                              <path d="M21.477,4.511c0,2.487-2.021,4.508-4.508,4.508c-2.49,0-4.509-2.021-4.509-4.508c0-2.49,2.02-4.511,4.509-4.511 C19.458,0,21.477,2.021,21.477,4.511z M16.972,27.68c-1.386-0.002-2.513,1.119-2.517,2.508c-0.003,1.391,1.117,2.518,2.505,2.52 c1.39,0.004,2.517-1.117,2.519-2.506C19.484,28.811,18.361,27.684,16.972,27.68z M31.451,17.352c0-0.906-0.734-1.641-1.641-1.641 c-0.908,0-1.644,0.732-1.644,1.641c0,0.904,0.733,1.643,1.644,1.643C30.716,18.994,31.451,18.258,31.451,17.352z M6.995,17.352 c0-1.585-1.284-2.87-2.87-2.87s-2.869,1.285-2.869,2.87c0,1.584,1.283,2.869,2.869,2.869S6.995,18.936,6.995,17.352z M26.962,7.354 c-0.504-0.506-1.319-0.504-1.825,0c-0.505,0.506-0.505,1.328,0,1.832c0.506,0.506,1.321,0.506,1.825,0S27.466,7.86,26.962,7.354z M9.973,24.354c-1.152-1.146-3.019-1.146-4.17-0.002c-1.151,1.146-1.152,3.012,0,4.16c1.152,1.148,3.018,1.15,4.168,0 C11.125,27.367,11.125,25.502,9.973,24.354z M27.251,27.631c0.658-0.662,0.658-1.734-0.002-2.396 c-0.658-0.658-1.726-0.658-2.385,0.004c-0.658,0.66-0.658,1.732,0,2.395C25.525,28.293,26.591,28.293,27.251,27.631z M10.047,10.427c1.188-1.189,1.188-3.119,0-4.311c-1.188-1.189-3.115-1.189-4.305,0c-1.188,1.189-1.188,3.119,0.001,4.311 S8.858,11.618,10.047,10.427z"></path>
                            </g>
                          </g>
                        </svg>
                      </span>
                    )}
                  </button>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default connectLoginPopUp()(ForgotPasswordTab);
